"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieStateStore = void 0;
exports.getSessionCookie = getSessionCookie;
const oidc_client_ts_1 = require("oidc-client-ts");
const SESSION_COOKIE_NAME = 'moment-session';
const SESSION_COOKIE_DOMAIN = '.momentgolf.com';
function setSessionCookie(sub, expiresAt) {
    const value = encodeURIComponent(JSON.stringify({ sub, expiresAt }));
    const expires = new Date(expiresAt * 1000).toUTCString();
    document.cookie = `${SESSION_COOKIE_NAME}=${value}; domain=${SESSION_COOKIE_DOMAIN}; path=/; expires=${expires}; SameSite=Lax; Secure`;
}
function clearSessionCookie() {
    document.cookie = `${SESSION_COOKIE_NAME}=; domain=${SESSION_COOKIE_DOMAIN}; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax; Secure`;
}
function getSessionCookie() {
    const match = document.cookie
        .split('; ')
        .find((row) => row.startsWith(`${SESSION_COOKIE_NAME}=`));
    if (!match)
        return null;
    try {
        return JSON.parse(decodeURIComponent(match.split('=').slice(1).join('=')));
    }
    catch {
        return null;
    }
}
/**
 * Wraps WebStorageStateStore (localStorage) and keeps a lightweight
 * root-domain session fingerprint cookie in sync so all *.momentgolf.com
 * subdomains can detect an active session without sharing localStorage.
 */
class CookieStateStore extends oidc_client_ts_1.WebStorageStateStore {
    constructor() {
        super({ store: window.localStorage });
    }
    async set(key, value) {
        await super.set(key, value);
        try {
            const parsed = JSON.parse(value);
            const sub = parsed?.profile?.sub;
            const expiresAt = parsed?.expires_at;
            if (sub && expiresAt) {
                setSessionCookie(sub, expiresAt);
            }
        }
        catch {
            // non-user keys — no cookie action needed
        }
    }
    async remove(key) {
        const result = await super.remove(key);
        clearSessionCookie();
        return result;
    }
}
exports.CookieStateStore = CookieStateStore;
